define.alias("shared/components/shared/social/refresh-profile/linkedin", "calendar/components/shared/social/refresh-profile/linkedin");